module.exports = __webpack_public_path__ + "img/locker_in_color.fdda67f9.gif";